import IntlMessages from "util/IntlMessages";
import {Menu} from "antd";
import {Link} from "react-router-dom";
import React from "react";
import {useDispatch} from "react-redux";

import {THEME_TYPE_LITE} from "../../constants/ThemeSetting";
// import { employeeInhouseOffersList } from "../../appRedux/actions/Offer";
import moment from "moment";
import { DeleteKeysFromSession } from "../../routes/recruitment/screening/utils";
import { fetchAccountsOffersList, fetchContractConsultantList, fetchContractTeamOffersList, fetchEmployees, fetchEngineerOffersList, fetchProjectCoordinatorsOffersList, fetchSupportPersonsList, fetchTimeSheetAttachmentList } from "../../appRedux/actions";
import { levelsConst } from "../../constants/Constants";
import dayjs from "dayjs";

const ContractSidebar = ({navStyleClass, defaultOpenKeys, selectedKeys, themeType, user}) => {
  const currentDate = new Date();
  const defaultStartDate = dayjs(`${currentDate.getFullYear()}-${currentDate.getMonth()+1}-01`);
  const defaultEndDate = dayjs();  
  const dispatch = useDispatch();

  const keysToDeleteFromSession = ['pageSize','employeePageNo','profilePageNo','submissionPageNo',
    'assessmentPageNo','clientPagination','pocPageNo','ipPageNo','transferRequestPageNo','offersPageNo',
    'supportPersonsoffersPageNo','joiningPendingTablePageNumber','incompleteVarificationTablePageNumber',
    'varifiedTablePageNumber','consultantPageNumber','supportInvoicePageNo']
    
  const fetchDashboardData = () => {
    dispatch(fetchContractTeamOffersList({page:1, status:'j'}))
    dispatch(fetchContractTeamOffersList({page:1, verified:false}))
    dispatch(fetchContractTeamOffersList({page:1, verified:true}))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }
  const fetchContractPersonsList = () => {
    dispatch(fetchEmployees(1 ,null ,'contract'))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  const fetchConsultantList = () => {
    dispatch(fetchContractConsultantList({page:1}))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  const fetchTimesheetDashboardData = () => {
    dispatch(fetchAccountsOffersList({ page: 1, status: 'ongoing' }))
    dispatch(fetchAccountsOffersList({ page: 1, status: 'closed' }))
    // dispatch(fetchTimeSheetAttachmentList({ status: 'pending', attachment_type: 'vendor', page: 1 }))
    dispatch(fetchTimeSheetAttachmentList({ status: 'pending', page: 1 }))
    // dispatch(fetchTimeSheetAttachmentList({ status:'pending', attachment_type:'pay_stub', page:1 }))
    DeleteKeysFromSession(keysToDeleteFromSession)
  }

  return (
        <Menu defaultOpenKeys={[defaultOpenKeys]} selectedKeys={[selectedKeys]} theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'} mode="inline">
          <Menu.Item key="engineering.recruitment">
            <Link to={"/username/dashboard".replace('username', user.username)}
                  onClick={()=>fetchDashboardData()}>
              <span><i className="icon icon-auth-screen"/><IntlMessages id="sidebar.dashboard"/></span>
              </Link>
          </Menu.Item>
          <Menu.Item key="engineering.timesheetdashboard">
            <Link to={"/username/contract/timesheet-dashboard".replace('username', user.username)}
                onClick={()=>fetchTimesheetDashboardData()}
            >
              <span><i className="icon icon-auth-screen"/>Timesheet</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="contract.consultant">
            <Link to={"/username/contract/consultant/list".replace('username', user.username)}
                  onClick={()=>fetchConsultantList()}>
              <span><i className="icon icon-auth-screen"/><IntlMessages id="sidebar.consultants"/></span>
              </Link>
          </Menu.Item>
          { user && user.level && user.level <= levelsConst['Team Lead'] && 
          <Menu.Item key="contract.contrats">
              <Link to={"/".concat(user.username.concat("/contract/contract-person/list"))} 
              onClick={()=>fetchContractPersonsList()} > <i className="icon icon-card"/>
              Contract
              </Link>
          </Menu.Item>
            }
        </Menu>
);
};
export default ContractSidebar;
